import { render } from "./HamburgerMenu.vue?vue&type=template&id=2913e647"
import script from "./HamburgerMenu.vue?vue&type=script&lang=js"
export * from "./HamburgerMenu.vue?vue&type=script&lang=js"

import "./HamburgerMenu.vue?vue&type=style&index=0&id=2913e647&lang=css"
script.render = render

export default script